import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import Alert from 'react-s-alert';
import { get } from 'session';
import PropTypes from 'prop-types';
import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';
import LocationContent from './LocationContent';
import LocationModal from '../components/LocationModal';

const form = {
  keyword: '',
};

function LocationContainer({
  match,
  history,
  getLocationList,
  locationList,
  isLoading,
  removeLocation,
  locationListPager,
  getSingleLocation,
  getDistrictList,
  districtList,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);
  const [district, setDistrict] = useState({
    label: '',
    value: 0,
  });

  const handleOnChange = (e) => {
    setFormData({
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <LocationModal type="NEW" />,
      title: 'Add Location',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <LocationModal type="EDIT" updateList={data.attributes} locationId={data.id} />,
      title: 'Update Location',
      modalSize: 'modal-md',
    });
  };

  const handleChangeSelect = (e) => {
    setDistrict(e);
    getLocationList({ rptax_district_id: e.value, isPaginate: 1 });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this Location?',
      () => {
        removeLocation(data.id, () => {
          getLocationList({ isPaginate: 1 });
          const id = _.get(locationList, '0.id');
          if (id !== data.id) {
            history.push(`${id}`);
            getSingleLocation(id);
          } else {
            window.location.pathname = '/rpt/settings/property-locations/locations';
            history.replace({
              pathname: '/rpt/settings/property-locations/locations',
            });
          }
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getLocationList({ isPaginate: 1 });
    getDistrictList({ isPaginate: 1 });
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getLocationList({ isPaginate: 1, q: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  const token = get('token') || '';

  const [file, setFile] = useState({});

  const fileHandler = (e) => {
    setFile(e.target.files[0]);
  };

  const postFormData = url => (formdata, onProgress) => new Promise((resolve, reject) => {
    try {
      const xhr = new XMLHttpRequest();
      xhr.timeout = 300000;
      // eslint-disable-next-line no-unused-vars
      xhr.addEventListener('timeout', e => resolve({
        status: 400,
        message: 'Request Timeout, Please try again.',
      }));
      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', `Bearer ${token}`,);
      xhr.onload = () => {
        try {
          const jsonResponse = JSON.parse(xhr.response);
          const response = {
            status: xhr.status, // jsonResponse.status,
            data: jsonResponse,
          };
          resolve(response);
        } catch (err) {
          reject(err);
        }
      };
      xhr.onerror = () => {
        const errRes = {
          data: false,
          message: 'Oops..Something went wrong.',
        };
        Alert.error(errRes);
        return resolve(errRes);
      };
      if (xhr.upload) {
        xhr.upload.onprogress = (evt) => {
          if (evt.lengthComputable) {
            const progress = Math.ceil(((evt.loaded) / evt.total) * 100);
            if (onProgress) { onProgress(progress); }
          }
        };
      }
      xhr.send(formdata);
    } catch (err) {
      reject(err);
    }
  });

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const onUploadFile = async (e) => {
    e.preventDefault();

    const data = new FormData();
    try {
      data.append('file', file);
      data.append(
        'subject',
        'LOCATION'
      );
      const res = await postFormData(`${process.env.REACT_APP_WS}api/v1/rpt/administrator/settings/csv_imports`)(data);
      if (_.get(res, 'status') === 200) {
        Alert.success(_.get(res, 'data.message'));
        getLocationList({ isPaginate: 1 });
      }
      if (_.get(res, 'status') === 422) {
        Alert.error(_.get(res, 'data.message'));
      }
      if (_.get(res, 'status') === 400) {
        const message = _.get(res, 'data.errors.0.detail');
        Alert.error(message);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err, 'err');
    }
  };

  return (
    <div className="card-content-listing">
      <div className="ml-auto row-nav">
        <div className="float-left">
          <div className="form-group">
            {isLoading && (
              <button
                disabled
                type="button"
                className="btn btn-light btn-round border border-primary font-weight-bold px-4 ml-auto"
              >
                <i className="fa fa-spin fa-spinner" />
              </button>
            )}
          </div>
        </div>
        <div className="float-right">
          <div className="form-group">
            {!isLoading && (
              <input
                type="file"
                className="btn btn-link input-upload"
                onChange={fileHandler}
              />
            )}
          </div>
        </div>
        <div className="flow-right">
          <div className="form-group">
            <button type="button" onClick={onUploadFile} className="ml-2 btn btn-link button-upload">
              Upload
            </button>
          </div>
        </div>
      </div>
      <div className="p-0 mb-3 mt-3">
        <div className="container-fluid  px-0">
          <div className="d-inline w-auto d-flex justify-content-start m-3">
            <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
              Select District:
            </label>
            <div style={{ width: 250 }}>
              <Select
                styles={customStyle}
                placeholder="Select District"
                value={district}
                options={createDropdown(districtList)}
                onChange={handleChangeSelect}
              />
            </div>
          </div>
        </div>
      </div>
      <Route
        path={`${match.path}/:locationId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Locations"
            getData={getLocationList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:locationId?`}
            listName="Locations"
            label="Locations"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.name')}</div>
            )}
            isLoading={isLoading}
            selected={params.locationId}
            data={locationList}
            dataPager={locationListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:locationId?`}
                    render={() => (
                      <LocationContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                        isLoading={isLoading}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:locationId?`}
                  render={() =>
                    (!params.locationId || locationList.length > 0) ? (
                      <Redirect
                        to={`${match.url}/${_.get(locationList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

LocationContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getLocationList: PropTypes.instanceOf(Function).isRequired,
  locationList: PropTypes.instanceOf(Array).isRequired,
  locationListPager: PropTypes.instanceOf(Object).isRequired,
  removeLocation: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleLocation: PropTypes.instanceOf(Function).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  locationList: _.get(api, `${c.GET_LOCATIONS}.list`) || [],
  districtList: _.get(api, `${c.GET_DISTRICT_LIST}.list`) || [],
  locationListPager: _.get(api, `${c.GET_LOCATIONS}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_LOCATIONS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LocationContainer);
